import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/workspace/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/workspace/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/workspace/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @license lucide-react v0.460.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
import { forwardRef, createElement } from 'react';
import defaultAttributes from './defaultAttributes.js';
import { mergeClasses } from './shared/src/utils.js';
var Icon = forwardRef(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === void 0 ? 2 : _ref$strokeWidth,
      absoluteStrokeWidth = _ref.absoluteStrokeWidth,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      children = _ref.children,
      iconNode = _ref.iconNode,
      rest = _objectWithoutProperties(_ref, ["color", "size", "strokeWidth", "absoluteStrokeWidth", "className", "children", "iconNode"]);

  return createElement("svg", _objectSpread(_objectSpread({
    ref: ref
  }, defaultAttributes), {}, {
    width: size,
    height: size,
    stroke: color,
    strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
    className: mergeClasses("lucide", className)
  }, rest), [].concat(_toConsumableArray(iconNode.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        tag = _ref3[0],
        attrs = _ref3[1];

    return createElement(tag, attrs);
  })), _toConsumableArray(Array.isArray(children) ? children : [children])));
});
export { Icon as default };